import vars from '../../vars';

function formItemStateBorder(color) {
  return `border-bottom: ${vars.form.item.borderWidth} solid ${color};`;
}

export const formItemPartials = {
  default: `
        position: relative;
        min-height: 50px;
        display: flex;
        align-items: center;
        padding: 0 15px;
        width: 100%;
        box-sizing: border-box;
        border: 0;
        background-color: ${vars.newColor.lightGS2};
        outline: none;
        ::placeholder: {
          color: ${vars.newColor.darkGS3}
        }
    `,
  state: {
    default: `
        ${formItemStateBorder(vars.newColor.lightGS1)};
        transition: ${vars.transition.default};
        position: absolute;
        width: 100%;
        bottom: 0;
    `,
    hover: `
        ${formItemStateBorder(vars.newColor.darkGS3)};
    `,
    active: `
        ${formItemStateBorder(vars.newColor.blue2)};
    `,
    focus: `
        ${formItemStateBorder(vars.newColor.blue2)};
    `,
    complete: `
        ${formItemStateBorder(vars.newColor.green1)};
    `,
    warning: `
        ${formItemStateBorder(vars.newColor.orange1)};
    `,
  },
};
